import { render, staticRenderFns } from "./ConfigInfo.vue?vue&type=template&id=6a3574db&scoped=true&"
import script from "./ConfigInfo.vue?vue&type=script&lang=ts&"
export * from "./ConfigInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigInfo.vue?vue&type=style&index=0&id=6a3574db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3574db",
  null
  
)

export default component.exports